// extracted by mini-css-extract-plugin
module.exports = {"dataGridHolder":"members_dataGridHolder__3YgZi","editModal":"members_editModal__EIUl5","colorPicker":"members_colorPicker__2QgBc","circleColor":"members_circleColor__8hBOu"};